import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getStudentList = createAsyncThunk(
  "api/fetchData",
  async (token, { rejectWithValue }) => {
    const raw = JSON.stringify({});
    let config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/client/search?offset=0&limit=5000&orderBy=id&direction=DESC`,

        raw,
        config
      );
      return response;
    } catch (error) {
      let status = "error";
      let data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data;
    }
  }
);

const studentListSlice = createSlice({
  name: "api",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStudentList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStudentList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getStudentList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default studentListSlice.reducer;
